// Lead-capture `source` tags — the single source of truth for the
// strings the /rent surface POSTs to /leads/capture. Keeping them here
// (instead of inline in Rent.tsx) means the two rent triggers can't
// drift apart, and the pro inbox can filter leads by an exact,
// grep-able value rather than a magic string duplicated at the callsite.
//
// These values are LIVE: they land in `chat_leads.source` and are what
// the pro inbox filters on. Do NOT rename an existing value without a
// data migration — old rows keep the old string.
//
//   rentChat    — the generic after-2-replies rent lead card.
//   rentCommute — fired right after an assistant turn that used the
//                 transit_commute_estimate tool, i.e. the highest-intent
//                 "I care about this route/area" moment.
export const LEAD_SOURCE = {
  rentChat: "rent-chat",
  rentCommute: "rent_commute",
} as const;

export type LeadSource = (typeof LEAD_SOURCE)[keyof typeof LEAD_SOURCE];
